export default __webpack_public_path__ + "static/media/google.acca6828.svg";